import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  HireTouchDubaiIcon,
  HireReqDubaiIcon,
  HireAssembleDubaiIcon,
  HireOnboardingDubaiIcon,
  HireScaleDubaiIcon,
} from "../../../app-constants";
import HtmlParser from "react-html-parser";

const process = [
  {
    number: "01",
    title: `Define Project`,
    txt: `<p>Consult with us to outline your project requirements, so we can help you match it with the right developers.</p>`,
    icon: HireTouchDubaiIcon,
  },
  {
    number: "02",
    title: `Browse Our Talent Pool`,
    txt: `<p>Explore our proven talent pool of top app developers in KSA with diverse skills and expertise.</p>`,
    icon: HireReqDubaiIcon,
  },
  {
    number: "03",
    title: `Developer Profiles`,
    txt: `<p>Check the profiles of potential developers, including their experience, portfolio, and client feedback.</p>`,
    icon: HireAssembleDubaiIcon,
  },
  {
    number: "04",
    title: ` Interview & Selection`,
    txt: `<p>Conduct interviews to assess developer skills and communication, considering your requirements before making your selection.</p>`,
    icon: HireOnboardingDubaiIcon,
  },
  {
    number: "05",
    title: `Onboard & Start Development`,
    txt: `<p>Once you've chosen your developers, we help you onboard them right away to start your project development process.</p>`,
    icon: HireScaleDubaiIcon,
  },
];

function Simplifiedprocess() {
  return (
    <div className="simplified_process p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={8}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Experience a Simplified Process To Hire Top App Developers In KSA
            </h2>
            <p>
              To hire mobile app developers in KSA is quite a challenging task
              as the success of any business highly depends on it. Therefore, we
              keep the hiring process simple for the ease of our clients.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="">
            <div className="process_main">
              {process.map((item, index) => (
                <div className="process_box_mob">
                  <div className="step_num">{item.number}</div>
                  <div className="process_flex">
                    <div className="process_box_head">
                      <strong>STEP {index + 1}</strong>
                      <h5>{HtmlParser(item.title)}</h5>
                    </div>
                    <div className="process_box_img">{item.icon}</div>
                  </div>
                  <div className="process_box_mob_content">
                    {HtmlParser(item.txt)}
                  </div>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Simplifiedprocess;
